import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UtilitaService } from '../services/utilita.service';
import { PresidentiDettaglioComponent } from './presidenti-dettaglio/presidenti-dettaglio.component';

@Component({
  selector: 'app-presidenti',
  templateUrl: './presidenti.component.html',
  styleUrls: ['./presidenti.component.css']
})
export class PresidentiComponent implements OnInit {
  lstElenco: any;
  lstElencoPerUpdateFilter: any;
  txtFiltra: any;

  constructor(private srvUtilita: UtilitaService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getLista();
  }

  getLista() {
    this.srvUtilita.getLista('Utenti/GetPresidentiLista').subscribe((res: any) => {
      this.lstElenco = res
      this.lstElencoPerUpdateFilter = res;
      //   console.log('res', res)
    })
  }

  btnAggiungiModifica(iValore: number) {
    let dialogRef: MatDialogRef<any> = this.dialog.open(PresidentiDettaglioComponent, {
      width: '720px',
      disableClose: false,
      data: { iValore: iValore }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.txtFiltra = '';
        this.getLista();
      })
  }

  updateFilter(event: any) {
    const val = event.target.value.toLowerCase()
    const columns = Object.keys(this.lstElencoPerUpdateFilter[0])
    columns.splice(columns.length - 1)
    if (!columns.length) {
      return
    }
    this.lstElenco = this.lstElencoPerUpdateFilter;
    const rows = this.lstElenco.filter(function (d: any) {
      for (let i = 0; i <= columns.length; i++) {
        const column = columns[i]
        if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
          return true
        }
      }
    })
    this.lstElenco = rows
  }
}
